import { useEffect } from 'react';

// Hook designed to run like useEffect, but with a delay. If the callback
// is triggered twice or the component unmounts, the initial call is canceled.
// This is helpful for offloading performance-heavy calls
const useOnceAfterDelay = (
  delay: number,
  callback: () => void,
  deps?: ReadonlyArray<any>,
): void => {
  useEffect(() => {
    const newTimeout = setTimeout(callback, delay);

    return () => clearTimeout(newTimeout);
  }, deps ?? []);
};

export default useOnceAfterDelay;
